<span class="rcp-list-flt-content">
    <span class="rcp-list-filter-txt">Filter By: </span>
    
    <owc-select-dropdown
      [value]="selSources"
      [limit]="4"
      [placeholder]="sourcePlaceholder"
      [showApplyButton]="true"
      [multiple]="sourceList.length > 0"
      [disabled]="sourceList.length < 1"
      (valueChange)="sourceListValue($event)"
      rounded
    >
    @for (item of sourceList; track item.value) {
        <owc-list-item [value]="item">
          {{item?.label}}
        </owc-list-item>
    }
    </owc-select-dropdown>

    <owc-select-dropdown
      [value]="selWarnings"
      [limit]="4"
      [placeholder]="warningPlaceholder"
      [showApplyButton]="true"
      [multiple]="warningsList.length > 0"
      [disabled]="warningsList.length < 1"
      (valueChange)="warningListValue($event)"
      rounded
    >
    @for (item of warningsList; track item.value) {
        <owc-list-item [value]="item">
          {{item?.label}}
        </owc-list-item>
    }
    </owc-select-dropdown>
</span>
